import PropTypes from 'prop-types';

import { IconButton } from '@mui/material';

import { varHover } from 'src/components/animate';
import Iconify from "src/components/iconify/index";

// ----------------------------------------------------------------------

export default function EmployeeLinkButton({ sx }) {
  return (
    <IconButton
      component="a"
      href={import.meta.env.VITE_EMPLOYEE_LINK}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      aria-label="settings"
      sx={{
        width: 40,
        height: 40,
        ...sx,
      }}
    >
      <Iconify icon="solar:shield-user-bold-duotone" width={24} />
    </IconButton>
  );
}

EmployeeLinkButton.propTypes = {
  sx: PropTypes.object,
};
